export default "__VITE_ASSET__jpFNMpWy__"